// extracted by mini-css-extract-plugin
module.exports = {"subscriptionOfferModal":"h6","header":"h7","body":"h8","buttonRow":"h9","buttonWrapper":"h-","button":"h_","changePlanWrapper":"ia","planCard":"ib","planName":"ic"};